import React from "react";
import { ReactSVG } from "react-svg";
import "./BenefitsCard.scss";

const BenefitsCard = ({ benefit, icon }) => (
    <div className="benefits-card">
        <ReactSVG src={icon} className="benefits-card__icon" alt="Icon" />
        <div className="benefits-card__title">
            <p>{benefit}</p>
        </div>
    </div>
);

export default BenefitsCard;
